export const addCustomerPopup = '/customerPopup';
export const getCustomerPopups = '/customerPopup';
export const deleteCustomerPopups = '/customerPopup';
export const updateCustomerPopups = '/customerPopup';
export const updateCustomerPopupStatusById = '/customerPopup/update-status/';
